import posthog from 'posthog-js';
import getEnvironment from '../../utils/getEnvironment';

class AnalyticsService {
  getPosthogClient = () => {
    if (typeof window !== 'undefined' && window.posthog) {
      return window.posthog;
    }
    return posthog;
  };

  init = () => {
    const environment = getEnvironment();
    this.registerGlobalProperties({
      environment,
      env: environment
    });
  };

  identifyUser = ({ userId, email, name }) => {
    if (!userId) return;

    const client = this.getPosthogClient();
    if (!client || typeof client.identify !== 'function') return;

    client.identify(String(userId), {
      email: email || '',
      name: name || ''
    });
  };

  registerGlobalProperties = (properties = {}) => {
    const client = this.getPosthogClient();
    if (!client || typeof client.register !== 'function') return;

    client.register(properties);
  };

  capture = (eventName, properties = {}) => {
    if (!eventName) return;

    const client = this.getPosthogClient();
    if (!client || typeof client.capture !== 'function') return;

    try {
      client.capture(eventName, properties);
    } catch (e) {
      // Analytics nunca deve quebrar o fluxo operacional.
    }
  };
}

export default new AnalyticsService();
